import {
  styled,
  type HTMLStyledProps,
  type StyledComponent,
} from '@/styled-system/jsx'
import { text, type TextVariantProps } from '@/styled-system/recipes'
import { useMemo, type ElementType } from 'react'

export type TextProps = {
  as?: ElementType
} & TextVariantProps &
  HTMLStyledProps<ElementType>

export const Text = (props: TextProps) => {
  const { as = 'span', ...localProps } = props
  const Dynamic = useMemo(
    () => styled(as, text) as StyledComponent<ElementType>,
    [as]
  )

  return <Dynamic {...localProps} />
}
